import React from 'react'
import { BookOpen, Braces, Lightbulb, MonitorPlay, PresentationIcon, Zap } from 'lucide-react'

export const guideContentTypes = [
  'fundamentals',
  'methods',
  'insights',
  'tutorials',
  'demos',
  'glossary',
] as const

export type GuideContentType = (typeof guideContentTypes)[number]

export const guideContentTypeLabels: Record<GuideContentType, string> = {
  fundamentals: 'Fundamentals',
  methods: 'Methods',
  insights: 'Insights',
  tutorials: 'Tutorials',
  demos: 'Demos',
  glossary: 'Glossary',
}

export const guideBadgeClassMap: Record<GuideContentType, string> = {
  fundamentals: 'bg-pink-200 text-pink-900 hover:bg-pink-200',
  methods: 'bg-lime-200 text-lime-900 hover:bg-lime-200',
  insights: 'bg-purple-100 text-purple-900 hover:bg-purple-100',
  tutorials: 'bg-yellow-100 text-yellow-900 hover:bg-yellow-100',
  demos: 'bg-green-100 text-green-900 hover:bg-green-100',
  glossary: 'bg-slate-100 text-slate-900 hover:bg-slate-100',
}

export const guideContentTypeDescriptions: Record<GuideContentType, string> = {
  tutorials: 'Learn how to use key features with step-by-step interactive videos.',
  demos: 'Watch how Resilience Explorer® can be leveraged for real-world projects.',
  insights:
    'Read our thought-provoking articles on risk and resilience and the latest trends in policy, research and practice.',
  methods:
    'Detailed descriptions of the models, assumptions, and computational logic which underpin Resilience Explorer®.',
  fundamentals:
    'Find answers to your questions and learn more about different concepts using our knowledge base.',
  glossary: 'Understand the meaning of terms used in Resilience Explorer®.',
}

export const guideIconMap: Record<GuideContentType, React.ReactNode> = {
  fundamentals: React.createElement(MonitorPlay, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  methods: React.createElement(Braces, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  insights: React.createElement(Lightbulb, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  tutorials: React.createElement(BookOpen, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  demos: React.createElement(PresentationIcon, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  glossary: React.createElement(BookOpen, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
}
